import React, { useRef, useEffect, useState } from "react";
import "./styles.scss";
import ModalPDF from "../ModalPDF";
import ModalIMG from "../ModalIMG";
import ModalYouTube from "../ModalYouTube";
import Modal from "../Modal";

type Props = {
  subCategories: any;
  // children: React.ReactNode;
  isOpenSub: boolean;
  onClickSub: () => void;
};

export default function SubCategoryItem({
  subCategories,
  // children,
  isOpenSub,
  onClickSub
}: Props) {
  const contentSubRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState<number>(0);
  const [showPdf, setShowPdf] = useState<Boolean>(false);
  const [showIMG, setShowIMG] = useState<Boolean>(false);
  const [showYouTube, setShowYouTube] = useState<Boolean>(false);
  const [urlPdfView, setUrlPdfView] = useState<string | null>(null);
  const [subUrl, setSubUrl] = useState<string | null | undefined>(null);
  const openForType = (mineType:number, url:string, subUrl?:string | null | undefined) => {
      setUrlPdfView(url);
      setSubUrl(subUrl);

      if(mineType === 1){
        setShowPdf(true);
      }else if(mineType === 2){
        setShowIMG(true);
      }else if(mineType === 3){
        setShowYouTube(true);
      }else
        window.open(url, '_blank');
  }

  const compartilharWhatsApp = (text:string) => {
    const texto = encodeURIComponent("Olha isso aqui: "+text);
    const url = `https://wa.me/?text=${texto}`;
    window.open(url, '_blank');
  };

  const handleShare = async (mineType:number, url: string) => {
    var text = " - "+url;
    if (navigator.share) {
        try {
          if(mineType === 1){
            await navigator.share({title: "Documento PDF",text: "Segue o PDF:",url: url});
          }else if(mineType === 2){
            await navigator.share({title: "Documento Imagem",text: "Segue a imagem:",url: url});
          }else if(mineType === 3){
            await navigator.share({title: "Vídeo do youtTube",text: "Segue o link do YouTube:", url: url});
          }else
            await navigator.share({title: "Link",text: "Segue o link:", url: url});
        } catch (error) {
            compartilharWhatsApp(text);
            console.error("Erro:", error);
        }
    } else {
        compartilharWhatsApp(text);
        alert("Compartilhamento não suportado.");
    }
  };

  useEffect(() => {
    if (isOpenSub && contentSubRef.current) {
      setMaxHeight(contentSubRef.current.scrollHeight);
    } else {
      setMaxHeight(0);
    }
  }, [isOpenSub]);

  return (
    <div style={{ marginBottom: 10 }}>
      {
        (showPdf && urlPdfView) &&
            <ModalPDF fileUrl={urlPdfView} titleType="PDF" onClose={() => setShowPdf(false)} />
      }
      {
        (showIMG && urlPdfView) &&
            <ModalIMG fileUrl={urlPdfView} onClose={() => setShowIMG(false)} />
      }
      {
        (showYouTube && urlPdfView) &&
            <ModalYouTube fileUrl={urlPdfView} subUrl={subUrl} onClose={() => setShowYouTube(false)} />
      }
      {
        (subCategories.title==="UNICO") ?
        <>
          {
            subCategories?.isSeparator !== true ?
            <>
            {
              subCategories.itemLinks?.map((item:any, index:number) => (
              <>
              {
                  (item.item) &&
                  <div 
                      style={{
                        background: "#ebebeb",
                        paddingLeft: 10,
                        paddingRight: 0,
                        minHeight: 40,
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 10,
                        position: "relative" // importante
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
                        <i className="mdi mdi-play-circle" style={{ color: '#1b8e3e', fontSize: 20 }}></i>
                        
                        <div style={{ marginLeft: 8 }}>
                          {item.item.title}
                          <span style={{ display: 'block', color: '#8f8c8c' }}>
                            {item.item.subTitle}
                          </span>
                        </div>
                      </div>

                      <div 
                        onClick={() => openForType(item.item.fileMimeType, item.item.urlFile, item.item.subUrl)}
                        style={{
                          cursor: 'pointer',
                          background: "#1b8e3e",
                          color:'#ffffff',
                          padding: "10px 15px",
                          marginTop: -10,
                          marginBottom: -10,
                          borderRadius: 4,
                          boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
                        }}
                      >
                        <i className="mdi mdi-play-circle"></i>{" "}
                        {(item.item.fileMimeType === 3) ? "ASSISTIR" : "ABRIR"}
                      </div>
                    </div>
              }
              </>
              ))
            }
            </> :
            <>
              <div style={{background: "#ffffff", padding:10, display: "flex", alignItems: "center"}}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6, paddingBottom: 3, width: '100%', fontWeight: 'bold', borderBottom: '1px solid #e0e0e0', color:'#248741' }}>
                  <i className="mdi mdi-arrow-down-drop-circle" style={{ color: '#97f80c', fontSize: 20 }} />
                  {subCategories.title}
                </span>
              </div>
            </>
          }
        </>
        :
        <>
          {
            subCategories.isSeparator !== true ?
            <>
              <div
                onClick={onClickSub}
                className="boxCategory"
                style={{backgroundColor: isOpenSub ? "#1B8E3E" : "#666666"}}
              >
                <div className="boxTitleOpen" style={{textAlign: isOpenSub ? "left" : "center", color:"#fff"}}>
                  {subCategories.title}
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifySelf: "end",
                    marginTop: 0
                  }}
                >
                  <div
                    style={{
                      width: 21,
                      height: 21,
                      color: "#fff",
                      backgroundColor:  "transparent",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <i
                      className="mdi mdi-chevron-double-down"
                      style={{
                        transition: "0.3s",
                        transform: isOpenSub ? "rotate(180deg)" : "rotate(0deg)",
                        fontSize: 18
                      }}
                    />
                  </div>
                </div>
                {
                  isOpenSub && (
                  <div
                    style={{
                      gridColumn: "1 / -1", // 👈 ocupa todas colunas
                      width: "90%",
                      height: 1,
                      backgroundColor: "rgb(204 204 204 / 42%)",
                      margin: "2px auto 0 auto"
                    }}
                  />
                  )
                }
                
              </div>

              <div
                style={{
                  overflow: "hidden",
                  maxHeight: isOpenSub ? 2000 : 0,
                  transition: "height 0.3s ease"
                }}
              >
                <div ref={contentSubRef} className="boxContent" style={{backgroundColor: "#f7f7f7",}}>
                  {
                    subCategories.suTitle &&
                      <p>{subCategories.suTitle}</p>
                  }
                  {
                    (subCategories?.itemLinks && (subCategories?.itemLinks?.length??0) > 0) ?
                    <>
                      <div style={{background: "#ffffff",padding:0, paddingLeft:13,display: "flex",alignItems: "center"}}>
                        <div style={{marginBottom: 0, cursor:'pointer'}}>
                            <span style={{fontSize:7}}>Visualizar</span>
                        </div>
                        <div style={{marginBottom: 0, marginLeft:10, cursor:'pointer'}}>
                            <span style={{fontSize:7}}>Enviar</span>
                        </div>
                        <div style={{flex: 1,marginBottom: 0}}>
                            
                        </div>
                      </div>
                    {subCategories?.itemLinks
                        ?.slice()
                        .sort((a:any, b:any) => a.item.ordem - b.item.ordem)
                        ?.map((it:any, index:number) => (
                          <>
                          {
                            it.item.fileMimeType === 6 ?
                              <div style={{background: "#ffffff", padding:10, display: "flex", alignItems: "center"}}>
                                <span style={{ display: 'flex', alignItems: 'center', gap: 6, paddingBottom: 3, width: '100%', fontWeight: 'bold', borderBottom: '1px solid #e0e0e0', color:'#248741' }}>
                                  <i className="mdi mdi-arrow-down-drop-circle" style={{ color: '#97f80c', fontSize: 20 }} />
                                  {it.item.title}
                              </span>
                              </div>
                              :
                              <div style={{background: "#ffffff", padding:10, display: "flex", alignItems: "center"}}>
                                  <div style={{marginBottom: 0, cursor:'pointer'}} onClick={()=>{openForType(it.item.fileMimeType, it.item.urlFile, it.item.subUrl)}}>
                                      <span>
                                          <i className="mdi mdi-eye-outline" style={{padding:'2px 5px', margin:'0px 4px', marginRight:13, background:'#073', color:'#FFFFFF', borderRadius:5}}></i>
                                      </span>
                                  </div>

                                  <div style={{marginBottom: 0, cursor:'pointer'}} onClick={()=>{handleShare(it.item.fileMimeType, it.item.urlFile)}}>
                                      <span>
                                          <i className="mdi mdi-telegram" style={{padding:'2px 5px', margin:'0px 4px', marginRight:15, background:'#073', color:'#FFFFFF', borderRadius:5}}></i>
                                      </span>
                                  </div>

                                  <div style={{flex: 1, marginBottom: 0}}>
                                      {it.item.title} - {it.item.fileMimeType}
                                      {it.item.subTitle && (
                                          <span style={{ color: '#8f8c8c' }}>
                                              {" "} - {it.item.subTitle}
                                          </span>
                                      )}
                                  </div>
                              </div>
                          } 
                          </>
                    ))}
                    </>
                    :
                      <>
                        <div style={{background: "#ffffff", padding:10, display: "flex", alignItems: "center"}}>
                          <span style={{ display: 'flex', alignItems: 'center', gap: 6, paddingBottom: 3, width: '100%', fontWeight: 'bold', borderBottom: '1px solid #e0e0e0', color:'#248741' }}>
                            <i className="mdi mdi-arrow-down-drop-circle" style={{ color: '#97f80c', fontSize: 20 }} />
                            {subCategories.title}
                          </span>
                        </div>
                      </>
                  }
                </div>
              </div>
                <Modal />
            </>
            :
            <>
              <div style={{background: "#ffffff", padding:10, display: "flex", alignItems: "center"}}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6, paddingBottom: 3, width: '100%', fontWeight: 'bold', borderBottom: '1px solid #e0e0e0', color:'#248741' }}>
                  <i className="mdi mdi-arrow-down-drop-circle" style={{ color: '#97f80c', fontSize: 20 }} />
                  {subCategories.title}
                </span>
              </div>
            </>
          }
        </>
        
      }
    </div>
  );
}